import { colors, media, radius, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

import { StepperProps } from '.';

type StepperWrapperProps = Pick<StepperProps, 'marginTop'>;

export const StepperWrapper = styled.div<StepperWrapperProps>`
  ${({ marginTop = 'none' }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${spacing[marginTop]};
    width: 100%;
    height: 4rem;
  `}
`;

export const TextWrapper = styled.div`
  display: flex;
`;

export const StepperIndicator = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${spacing.small};
`;

interface StepDotProps {
  isActive: boolean;
}

export const StepDot = styled.div<StepDotProps>`
  ${({ isActive, theme }) => css`
    width: ${media.greaterThan('tablet') ? '1rem' : '0.5rem'};
    height: ${media.greaterThan('tablet') ? '1rem' : '0.5rem'};
    background-color: ${isActive ? theme.primaryColor : colors.neutral_light};
    border-radius: ${radius.large};
    transition: background-color 0.3s ease-in-out;

    &:not(:last-child) {
      margin-right: ${media.greaterThan('tablet') ? '0.4rem' : '0.2rem'};
    }
  `}
`;
